var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaptionsOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83 1.00004H18C19.1 1.00004 20 1.90004 20 3.00004V15C20 15.05 19.99 15.1 19.98 15.16L16.6 11.78C16.84 11.59 17 11.32 17 11V10.5C17 10.22 16.78 10 16.5 10H16C15.72 10 15.5 10.22 15.5 10.5H15.33L13.5 8.67004V7.50004H15.5C15.5 7.78004 15.72 8.00004 16 8.00004H16.5C16.78 8.00004 17 7.78004 17 7.50004V7.00004C17 6.45004 16.55 6.00004 16 6.00004H13C12.45 6.00004 12 6.45004 12 7.00004V7.17004L5.83 1.00004ZM19.49 18.9C19.1 19.29 18.47 19.29 18.08 18.9L16.18 17H4C2.89 17 2 16.1 2 15V3.00004C2 2.95004 2.02 2.90004 2.02 2.85004L1.1 1.93004C0.709995 1.54004 0.709995 0.910039 1.1 0.520039C1.49 0.130039 2.12 0.130039 2.51 0.520039L19.48 17.49C19.88 17.88 19.88 18.51 19.49 18.9ZM10 10.83L9.17 10H9C8.72 10 8.5 10.22 8.5 10.5H6.5V7.50004H6.67L5.4 6.22004C5.16 6.41004 5 6.68004 5 7.00004V11C5 11.55 5.45 12 6 12H9C9.55 12 10 11.55 10 11V10.83Z",
    fill: "#001B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptionsOff);
export default __webpack_public_path__ + "static/media/captions-off.311857871fd0474b11de6911ba06499d.svg";
export { ForwardRef as ReactComponent };